import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import cl from "classnames";

//
import IconWrapper from "../components/icon-wrapper/IconWrapper";

const samarkandLink = [
  "https://yandex.uz/maps/org/choriqul_shaymatov_gavhari/42398724213/?utm_medium=mapframe&utm_source=maps",
  "https://yandex.uz/maps/10334/samarkand/category/medical_center_clinic/184106108/?utm_medium=mapframe&utm_source=maps",
  "https://yandex.uz/maps/10334/samarkand/category/vision_correction/184106066/?utm_medium=mapframe&utm_source=maps",
  "https://yandex.uz/map-widget/v1/?ll=66.960924%2C39.655460&mode=search&oid=42398724213&ol=biz&z=16.86",
];

const xatirchiLink = [
  "https://yandex.uz/maps/org/138563633086/?utm_medium=mapframe&utm_source=maps",
  "https://yandex.uz/maps/10335/tashkent/category/concert_hall/184105902/?utm_medium=mapframe&utm_source=maps",
  "https://yandex.uz/maps/10335/tashkent/category/house_of_culture/184105876/?utm_medium=mapframe&utm_source=maps",
  "https://yandex.uz/map-widget/v1/?from=mapframe&ll=69.244459%2C41.294352&mode=poi&poi%5Bpoint%5D=69.241258%2C41.308726&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D138563633086&z=14.4",
];

export default function Location({ bg = "--white" }) {
  const { t } = useTranslation();
  const [location, setLocation] = useState("samarkand");
  const [linkArr, setLinkArr] = useState([...samarkandLink]);

  useEffect(() => {
    if (location === "samarkand") {
      setLinkArr([...samarkandLink]);
    } else {
      setLinkArr([...xatirchiLink]);
    }
  }, [location]);

  function handleLocationChange(newLocation) {
    setLocation(newLocation);
  }

  return (
    <StyledLocation $bg={bg}>
      <div className="container">
        <div className="location__map">
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              width: "100%",
              height: "100%",
            }}
          >
            <a
              href={linkArr[0]}
              style={{
                color: "eee",
                fontSize: "12px",
                position: "absolute",
                top: "0px",
              }}
            >
              Чорикул Шайматов Гавхари
            </a>
            <a
              href={linkArr[1]}
              style={{
                color: "eee",
                fontSize: "12px",
                position: "absolute",
                top: "14px",
              }}
            >
              Медцентр, клиника в Самарканде
            </a>
            <a
              href={linkArr[2]}
              style={{
                color: "eee",
                fontSize: "12px",
                position: "absolute",
                top: "28px",
              }}
            >
              Коррекция зрения в Самарканде
            </a>
            <iframe
              src={linkArr[3]}
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen={true}
              style={{ position: "relative" }}
            ></iframe>
          </div>
        </div>
        <div className="location__wrap">
          <div className="location__left"></div>
          <div className="location__right">
            <h1 dangerouslySetInnerHTML={{ __html: t("locationTitle") }} />
            <div className="location__right__btns">
              <button
                className={cl({
                  active: location === "samarkand",
                })}
                onClick={() => handleLocationChange("samarkand")}
              >
                {t("locationSamarkand")}
              </button>
              <button
                className={cl({
                  active: location === "xatirchi",
                })}
                onClick={() => handleLocationChange("xatirchi")}
              >
                {t("locationXatirchi")}
              </button>
            </div>
            <ul className="location__right__txtAddress">
              {location === "samarkand" ? (
                <li>
                  <i className="icon icon-location"></i>
                  <a
                    href="https://yandex.uz/maps/10334/samarkand/house/Yk8YfwFgQEcDQF1jfXp0dHhmbQ==/?from=mapframe&ll=66.960924%2C39.655460&z=16"
                    target="__blank"
                    className="hover-underline"
                    dangerouslySetInnerHTML={{
                      __html: t("locationAddressText"),
                    }}
                  ></a>
                </li>
              ) : (
                <li>
                  <i className="icon icon-location"></i>
                  <a
                    href="https://yandex.uz/maps"
                    target="__blank"
                    className="hover-underline"
                    dangerouslySetInnerHTML={{
                      __html: t("locationAddressText2"),
                    }}
                  ></a>
                </li>
              )}
            </ul>
            <ul className="location__right__contacts">
              <li>
                <IconWrapper />
                <div>
                  {location === "samarkand" ? (
                    <a href="tel:+998954100014" className="hover-underline">
                      +998 (95) 410 00 14
                    </a>
                  ) : (
                    <a href="tel:+998979210014" className="hover-underline">
                      +998 (97) 921 00 14
                    </a>
                  )}
                </div>
              </li>
              <li>
                <IconWrapper icon="mail" />
                <div>
                  {location === "samarkand" ? (
                    <a
                      href="mailto:samarkand@gmail.com"
                      className="hover-underline"
                    >
                      samarkand@gmail.com
                    </a>
                  ) : (
                    <a
                      href="mailto:xatirchi@gmail.com"
                      className="hover-underline"
                    >
                      xatirchi@gmail.com
                    </a>
                  )}
                </div>
              </li>
            </ul>
            <ul className="location__right__icons">
              <li>
                <a href="https://www.facebook.com/Kozklinika" target="__blank">
                  <IconWrapper
                    w={60}
                    h={60}
                    icon="facebook"
                    iconW={30}
                    iconH={30}
                    animation="scale&&rotate"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/kozklinika/"
                  target="__blank"
                >
                  <IconWrapper
                    w={60}
                    h={60}
                    icon="instagram"
                    iconW={30}
                    iconH={30}
                    animation="scale&&rotate"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@ChoriqulShaymatovGavhari"
                  target="__blank"
                >
                  <IconWrapper
                    w={60}
                    h={60}
                    icon="youtube"
                    iconW={30}
                    iconH={30}
                    animation="scale&&rotate"
                  />
                </a>
              </li>
              <li>
                <a href="https://t.me/kozklinika" target="__blank">
                  <IconWrapper
                    w={60}
                    h={60}
                    icon="telegram"
                    iconW={30}
                    iconH={30}
                    animation="scale&&rotate"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </StyledLocation>
  );
}

const StyledLocation = styled.section`
  position: relative;
  background-color: var(${(props) => props.$bg});

  .location__map {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    border: 1px solid var(--border);
  }

  .location {
    &__wrap {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 1fr;
      gap: 100px;
    }

    &__left {
      min-height: 700px;
    }

    &__right {
      padding: 140px 0 100px;
      height: 100%;

      h1 {
        color: var(--title);
        text-align: center;
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 32px;

        span {
          color: var(--light-blue);
        }
      }

      &__btns {
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 75%;
        margin: 0 auto;
        gap: 48px;
        margin-bottom: 48px;

        button {
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          cursor: pointer;
          padding: 14px 0;
          color: var(--black);
          background-color: transparent;
          border: 2px solid var(--black);
          border-radius: 32px;
          transition: 0.4s ease;

          &:hover {
            border-color: var(--light-blue);
            color: var(--light-blue);
          }

          &.active {
            background-color: var(--light-blue);
            border-color: var(--light-blue);
            color: var(--white);
            cursor: default;
          }
        }
      }

      &__txtAddress {
        display: flex;
        flex-direction: column;
        gap: 16px;

        li {
          display: flex;
          align-items: center;
          gap: 12px;

          i {
            background-color: var(--light-blue);
            width: 28px;
            height: 28px;
          }

          a {
            color: var(--black);
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            position: relative;

            &::after {
              background-color: var(--black);
            }
          }
        }
      }

      &__contacts {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 24px;
        margin-top: 48px;

        li {
          display: flex;
          align-items: center;
          gap: 20px;

          div:last-child {
            display: flex;
            flex-direction: column;
            gap: 6px;

            a {
              color: var(--black);
              font-size: var(--fs-body);
              font-style: normal;
              font-weight: var(--fw-medium);
              line-height: var(--lh-body);

              &::after {
                background-color: var(--black);
              }
            }
          }
        }
      }

      &__icons {
        margin-top: 32px;
        display: flex;
        gap: 24px;
      }
    }

    &__working-time {
      display: flex;
      align-items: center;
      gap: 20px;
      width: max-content;

      p {
        color: var(--title);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-body);
      }
    }
  }
`;
